export default "__VITE_ASSET__bTG65b4e__"